/** @format */

import React from "react";

export default () => (
  <svg width="23" height="23" viewBox="0 0 23 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7333 1L24 10.2V25.5333H1V10.2L11.7333 1Z" stroke="#191919" stroke-width="1.5"/>
<path d="M16.3332 17.0999V25.5332H8.66654V17.0999H16.3332Z" stroke="#191919" stroke-width="1.5"/>
</svg>

  

);
